import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  SvgIcon,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Search as SearchIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'use-debounce/lib';

const Container = ({ children }) => {
  return (
    <Box mt={3}>
      <Card>
        <CardContent>{children}</CardContent>
      </Card>
    </Box>
  );
};

const ToolbarFilters = ({ resetPage, name, setName, defaultCompany, setDefaultCompany }) => {
  const { t } = useTranslation('companies');
  const [nameValue, setNameValue] = useState(name);
  const [nameDebouncedValue] = useDebounce(nameValue, 500);

  const handleReset = () => {
    resetPage();
    setName('');
    setNameValue('');
    setDefaultCompany('all');
  };

  const handleCompanyChange = (e) => {
    setDefaultCompany(e.target.value);
    resetPage();
  };

  useEffect(() => {
    setName(nameDebouncedValue);
    resetPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameDebouncedValue, setName]);

  return (
    <Container>
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={12} sm={8} md={7}>
          <TextField
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="primary">
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              ),
            }}
            placeholder={t('labels.search_companies')}
            value={nameValue}
            onBlur={(e) => setName(e.target.value)}
            onChange={(e) => {
              setNameValue(e.target.value);
            }}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            fullWidth
            select
            name="defaultCompany"
            label={t('fields.default_company_select.name')}
            SelectProps={{ native: true }}
            value={defaultCompany}
            onChange={handleCompanyChange}
            variant="outlined"
          >
            <option value="all">{t('fields.default_company_select.all')}</option>
            <option value="default">{t('fields.default_company_select.default')}</option>
          </TextField>
        </Grid>

        <Grid item xs={12} md={2}>
          <Button fullWidth color="primary" variant="contained" onClick={handleReset}>
            {t('buttons.companies_list_clear_filters')}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

ToolbarFilters.propTypes = {
  resetPage: PropTypes.func,
  name: PropTypes.string,
  setName: PropTypes.func,
  defaultCompany: PropTypes.string,
  setDefaultCompany: PropTypes.func,
};

export default ToolbarFilters;
